<template>
    <span>| Versión {{ appVersion }} - 
        <span v-if="errorConexion" style="color:#ff3636">Error conectando al webservice de PalJetERP</span>
        <span v-else>{{ paljetWsVersion }}</span>
    </span>
</template>

<script>
import { version } from '../../../package.json'
export default { 
    data() {
        return {
            appVersion: version || '0',
            paljetWsVersion: 'Verificando...',
            errorConexion: false,
        }
    },
    mounted: async function() {

        await this.axios.get("./api/config").then(json => {

            const { api_paljet } = json.data;
            this.axios.get(api_paljet + '/sistema')
            .then(response => {
                this.paljetWsVersion = response.data.db.version;
            })
            .catch(e => {
                console.error('No se pudo conectar al webservice de PalJetERP en ' + api_paljet);
                this.errorConexion = true;
            });

        });
        
    }

};
</script>